import {AxiosRequestConfig} from 'axios';
import request from '../../../axios';
interface IGetRequirementViewProps {
  guid?: string;
  requirement_type: string;
}
export const getRequirementView = async ({
  guid,
  requirement_type,
}: IGetRequirementViewProps) => {
  const {data}: {data: RequirementViewData} = await request.get(
    `/api/v2/wanted/requirement-view/${guid}`,
    {params: {requirement_type}} as AxiosRequestConfig,
  );
  return data;
};
